// Port of api/fuel/app/classes/controller/api/monty/listing/columns.php
import DB from 'offline/db'
import {
	currentUserId,
	loadOwnedListing,
	persist,
	unauthorised
} from './shared'

export default function(params) {
	var userId = currentUserId(params)
	var listing = loadOwnedListing(userId, params.list)

	if (!userId) return unauthorised()
	if (!listing || listing.get_template()) return unauthorised()

	DB.run('UPDATE list SET list_columns = ? WHERE list_id = ?', [
		JSON.stringify(params.columns || []),
		listing.get_id()
	])

	return persist(loadOwnedListing(userId, listing.get_id()).to_array())
}
